<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Alterar valor da mensalidade
          </h4>
        </div>
        <div class="modal-body--scrollable">
          <table class="table table-striped modal__table">
            <tbody>
              <tr>
                <th>Id</th>
                <td>{{ selectedBill.id }}</td>
              </tr>
              <tr>
                <th>Encargos sendo aplicados</th>
                <td>{{ selectedBill.apply_charges | formatBoolean }}</td>
              </tr>
              <tr>
                <th>Número da parcela</th>
                <td>{{ selectedBill.contract_installment }}</td>
              </tr>
              <tr>
                <th>Data de vencimento</th>
                <td>{{ selectedBill.due_date | formatDate }}</td>
              </tr>
              <tr>
                <th>Valor atual</th>
                <td>{{ selectedBill.amount_with_charges | formatCurrency }}</td>
              </tr>
            </tbody>
          </table>
          <div class="modal-body">
            <div v-if="inputError" class="alert alert-danger">
              {{ inputError }}
            </div>
            <p>Novo valor:</p>
            <money-field
              label="Valor"
              v-model="newValue"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="changeBillValue">
            Salvar
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BillsService from 'services/BillsService';
import { MoneyField } from 'components/form';

export default {
  components: { MoneyField },
  data() {
    return {
      newValue: null,
      inputError: null,
    };
  },
  mounted() {
    this.newValue = this.selectedBill.full_amount;
  },
  computed: {
    ...mapState([
      'selectedBill',
    ]),
  },
  methods: {
    ...mapActions([
      'loadStudentBills',
    ]),
    changeBillValue() {
      this.$loader.show();
      BillsService.changeBillValue(this.selectedBill.id, Math.round(this.newValue * 100))
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.loadStudentBills();
          this.$alert.notifySuccess('Valor da mensalidade alterado com sucesso.');
          this.$emit('close');
        })
        .catch(({ body }) => {
          this.inputError = `Erro ao alterar o valor da mensalidade: ${body.message}`;
        })
        .finally(() => this.$loader.hide());
    },
  },
};
</script>
